import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const ConfirmDialog = ({ open, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        backgroundColor: '#424242',
        color: 'white',
        boxShadow: 24,
        borderRadius: 3,
        p: 2,
      },
    }}
  >
    <DialogTitle>Подтверждение</DialogTitle>
    <DialogContent>
      <Typography>Вы уверены, что хотите удалить этот проект?</Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="outlined" color="inherit">Отмена</Button>
      <Button onClick={onConfirm} variant="contained" color="error">Удалить</Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;